const cultural = [
  {
    title: "Solo Dancing",
    date: "29/09/2022",
    timing: "Round(1) 10:15 AM - 01:00 PM  Round(2) 02:30 PM - 03:00 PM",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. For Solo, Duet and Group dance team can comprise of 1, 2 and 3-16 members respectively.",
      "2. The songs must be proper with no offensive words.",
      "3. The participant must provide the track to the committee 24 hours prior to the performance.",
      "4. The group dance must not contain any sort of couple dance elements.",
      "5. The performance must be in proper dress code as assigned or the one appropriate for the college.",
      "Duration:",
      "Solo Dance:",
      "Round 1: 3 minutes",
      "Round 2: 4-5 minutes",
      "Group Dance:",
      "Round 1: 4-5 minutes",
      "Round 2: 7-8 minutes",
      "6. The Committee holds the right to cancel the performance on stage if found anything",
      "inappropriate and objectionable.",
    ],
  },
  {
    title: "Duet Singing",
    date: "29/09/2022",
    timing: "Round(1) 11:00 AM - 12:00 PM ",
    venue: "Auditorium",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. For Solo, Duet and Group singing team can comprise of 1, 2 and 4-6 members respectively.",
      "2. The entire competition is divided into two rounds.",
      "3. For the first round the participants are free to choose any singing genre of their choice.",
      "4. The participants qualifying 1 st round will only go to second round.",
      "5. For final round the genre would be given by judges and song can be of participant&#39;s choice.",
      "6. Duration:-",
      "Round 1: 3 minutes",
      "Round 2: 4-5 minutes",
      "7. The songs should only be in Hindi.",
      "8. There should not be any brusqueness or anything else which is catastrophic.",
      "9. The Performer should arrange the track and submit it to the committee at least two hours before the performance.",
      "10. The performer should be in right dress code.",
      "11. The performer should not come offstage or in between the audience while performing.",
      "12. The Committee holds the right to cancel the performance on stage if found any inappropriate and objectionable.",
    ],
  },
  {
    title: "Group Dancing",
    date: "29/09/2022",
    timing: "Round(1) 01:00 AM - 02:30 PM  ",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. For Solo, Duet and Group dance team can comprise of 1, 2 and 3-16 members respectively.",
      "2. The songs must be proper with no offensive words.",
      "3. The participant must provide the track to the committee 24 hours prior to the performance.",
      "4. The group dance must not contain any sort of couple dance elements.",
      "5. The performance must be in proper dress code as assigned or the one appropriate for the college.",
      "Duration:",
      "Solo Dance:",
      "Round 1: 3 minutes",
      "Round 2: 4-5 minutes",
      "Group Dance:",
      "Round 1: 4-5 minutes",
      "Round 2: 7-8 minutes",
      "6. The Committee holds the right to cancel the performance on stage if found anything",
      "inappropriate and objectionable.",
    ],
  },
  {
    title: "Stand Up comedy",
    date: "29/09/2022",
    timing: "12:15 PM - 01:45 PM",
    venue: "Auditorium",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. The script of the skit must be approved by the committee.",
      "2. The script should be submitted to the committee convener.",
      "3. There should not be any double meaning word or dialogues in the skit.",
      "4. The skit should be purely based on some social issues.",
      "5. There should not be any brusqueness or anything else which is catastrophic.",
      "6. Performer can use any props if required on the stage for performance with prior permission of the committee and arrangement ",
      "for the same should be made by the performer. The committee is not responsible for arrangement of anything as such.",
      "7. The performer should be in right dress code.",
      "8. The members should not exceed by 12 for skit.",
      "9. Duration: 15 minutes for skit.",
      "10. The Committee holds the right to cancel the performance on stage if found anything offensive.",
    ],
  },
  {
    title: "Fashion Show",
    date: "29/09/2022",
    timing: "Round(1) 03:00 PM - 04:10 PM  Round(2) 04:30 PM - 05:00 PM",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "Theme: Attire of different States.",
      " ",
      "1. The fashion show will be conducted in two rounds: ramp walk & judges roun",
      "2. Ramp walk will include the introduction and talent show and judges round will include the questioning round.",
      "3. The participant should arrange their dress by themselves.",
      "4. The dress code would be provided 72 hours prior to the event.",
      "5. One hour prior to the show the ramp chart would be provided to the participant.",
      "6. The Committee holds the right to cancel the performance on stage if found anything offensive.",
    ],
  },
  {
    title: "Solo Singing",
    date: "30/09/2022",
    timing: "Round(1) 09:15 AM - 11:00 AM  Round(2) 12:30 PM - 01:10 PM",
    venue: "Auditorium",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. For Solo, Duet and Group singing team can comprise of 1, 2 and 4-6 members respectively.",
      "2. The entire competition is divided into two rounds.",
      "3. For the first round the participants are free to choose any singing genre of their choice.",
      "4. The participants qualifying 1 st round will only go to second round.",
      "5. For final round the genre would be given by judges and song can be of participant&#39;s choice.",
      "6. Duration:-",
      "Round 1: 3 minutes",
      "Round 2: 4-5 minutes",
      "7. The songs should only be in Hindi.",
      "8. There should not be any brusqueness or anything else which is catastrophic.",
      "9. The Performer should arrange the track and submit it to the committee at least two hours before the performance.",
      "10. The performer should be in right dress code.",
      "11. The performer should not come offstage or in between the audience while performing.",
      "12. The Committee holds the right to cancel the performance on stage if found any inappropriate and objectionable.",
    ],
  },
  
  {
    title: "Duet Dancing",
    date: "30/09/2022",
    timing: "Round(1) 09:30 AM - 11:00  AM Round(2) 01:10 PM - 01:40 PM",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. For Solo, Duet and Group dance team can comprise of 1, 2 and 3-16 members respectively.",
      "2. The songs must be proper with no offensive words.",
      "3. The participant must provide the track to the committee 24 hours prior to the performance.",
      "4. The group dance must not contain any sort of couple dance elements.",
      "5. The performance must be in proper dress code as assigned or the one appropriate for the college.",
      "Duration:",
      "Solo Dance:",
      "Round 1: 3 minutes",
      "Round 2: 4-5 minutes",
      "Group Dance:",
      "Round 1: 4-5 minutes",
      "Round 2: 7-8 minutes",
      "6. The Committee holds the right to cancel the performance on stage if found anything",
      "inappropriate and objectionable.",
    ],
  },
  {
    title: "Group Singing",
    date: "30/09/2022",
    timing: "Round(1) 12:40 PM - 01:10 PM  Round(2) 03:40 PM - 04:00 PM",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. For Solo, Duet and Group singing team can comprise of 1, 2 and 4-6 members respectively.",
      "2. The entire competition is divided into two rounds.",
      "3. For the first round the participants are free to choose any singing genre of their choice.",
      "4. The participants qualifying 1 st round will only go to second round.",
      "5. For final round the genre would be given by judges and song can be of participant&#39;s choice.",
      "6. Duration:-",
      "Round 1: 3 minutes",
      "Round 2: 4-5 minutes",
      "7. The songs should only be in Hindi.",
      "8. There should not be any brusqueness or anything else which is catastrophic.",
      "9. The Performer should arrange the track and submit it to the committee at least two hours before the performance.",
      "10. The performer should be in right dress code.",
      "11. The performer should not come offstage or in between the audience while performing.",
      "12. The Committee holds the right to cancel the performance on stage if found any inappropriate and objectionable.",
    ],
  },
  {
    title: "Hindi Skit",
    date: "30/09/2022",
    timing: "11:30 AM - 12:30 PM",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. The script of the skit must be approved by the committee.",
      "2. The script should be submitted to the committee convener.",
      "3. There should not be any double meaning word or dialogues in the skit.",
      "4. The skit should be purely based on some social issues.",
      "5. There should not be any brusqueness or anything else which is catastrophic.",
      "6. Performer can use any props if required on the stage for performance with prior permission of the committee and arrangement ",
      "for the same should be made by the performer. The committee is not responsible for arrangement of anything as such.",
      "7. The performer should be in right dress code.",
      "8. The members should not exceed by 12 for skit.",
      "9. Duration: 15 minutes for skit.",
      "10. The Committee holds the right to cancel the performance on stage if found anything offensive.",
    ],
  },
  {
    title: "Follow the Beats",
    date: "30/09/2022",
    timing: "01:40 PM - 02:30 PM",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. The music played could be of any genre, and the songs will be continuously shuffled.",
      "2. Any obscene actions/steps shall result in the disqualification of the participant.",
      "3. The decision of the judges shall be final and binding.",
    ],
  }, 
  
  
  {
    title: "Battle of Bands",
    date: "30/09/2022",
    timing: "02:30 PM - 04:30 PM",
    venue: "Amphitheatre",
    bgColor: "blue",
    tag: "red",
    linkText: "Read Rules",
    rules: [
      "1. Each band must be registered with the cultural committee before the day of event.",
      "2. Band should reach the college one hour prior to the beginning of the event.",
      "3. Performance time should not exceed the given time limit.",
      "4. Songs performed must be Sufi. No metal, hard rock or any other will be allowed.",
      "5. The band members will not be granted permission to enter the audience in between the performance.",
      "6. No offensive words or actions will be entertained.",
      "7. Maximum number of members should be 10.",
      "8. The maximum time limit for each band is 20 mins.",
      "9. The committee holds the right to cancel the performance in case there is anything objectionable.",
    ],
  },
];
export default cultural;
